import { render, staticRenderFns } from "./SSOPairingForm.vue?vue&type=template&id=c5a11bea&scoped=true"
import script from "./SSOPairingForm.vue?vue&type=script&lang=ts"
export * from "./SSOPairingForm.vue?vue&type=script&lang=ts"
import style0 from "./SSOPairingForm.vue?vue&type=style&index=0&id=c5a11bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a11bea",
  null
  
)

export default component.exports